module.exports = __webpack_public_path__ + "img/logo.87f6234c.png";